import { TWidget } from 'widgets/Widget';

/**
 * @param Widget Base widget for extending
 * @returns RedirectToLink widget
 */
function RedirectToLinkClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory global
     * @class RedirectToLink
     * @augments Widget
     * @classdesc Appends `?redirectTo={currentURL}` to the element's href on init.
     * Used on the drop site account icon to pass the current page URL
     * back to the main site sign-in page.
     * @property {string} data-widget - Widget name `redirectToLink`
     */
    class RedirectToLink extends Widget {
        init() {
            super.init();

            const el = this.ref('self').get() as HTMLAnchorElement | null;

            if (el && el.href && window.location.href) {
                el.href += '?redirectTo=' + encodeURIComponent(window.location.href);
            }
        }
    }

    return RedirectToLink;
}

export type TRedirectToLink = ReturnType<typeof RedirectToLinkClassCreator>;

export type TRedirectToLinkInstance = InstanceType<TRedirectToLink>;

export default RedirectToLinkClassCreator;
